import { ReactNode } from 'react'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type RowProps = {
  children?: ReactNode
  className?: string
  grey?: boolean
  spaceBetween?: boolean
}

const Row = ({ children, className = '', grey, spaceBetween = false }: RowProps) => {
  return (
    <div
      className={classNames(
        'flex flex-row flex-nowrap items-center my-2',
        spaceBetween && 'justify-between',
        grey && 'text-neutral-500 fill-neutral-500',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default Row
